"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getShowMoreText = void 0;
const getShowMoreText = (showMore, open) => {
  if (!showMore) {
    return null;
  }
  return open ? showMore.translations?.showLess : showMore.translations?.showMore;
};
exports.getShowMoreText = getShowMoreText;
